<template>
    <nav class="user-menu-dropdown" :class="{ 'user-menu-dropdown--open': isOpen }">
        <div class="user-menu-dropdown__wrapper">
            <ul class="user-menu-dropdown__list">
                <li class="user-menu-dropdown__item user-menu-dropdown__item--wagers">
                    <a class="user-menu-dropdown__link" :href="myBetsLink" @click.prevent="$emit('myBetsClick')">
                        Moje sázky
                    </a>
                </li>
                <li class="user-menu-dropdown__item">
                    <button type="button" class="user-menu-dropdown__link" @click="showAccount()">Můj účet</button>
                </li>
                <li class="user-menu-dropdown__item">
                    <button type="button" class="user-menu-dropdown__link" @click="showDeposit()">Vložit</button>
                </li>
                <li class="user-menu-dropdown__item">
                    <button
                        type="button"
                        class="user-menu-dropdown__link user-menu-dropdown__link--logout"
                        @click="logout()"
                    >
                        Odhlásit
                        <DsSystemIcon name="power" class="user-menu-dropdown__logout-icon" />
                    </button>
                </li>
                <li class="user-menu-dropdown__item user-menu-dropdown__item--balance">
                    <BalanceToggle v-model="showBalance" />
                </li>
            </ul>
        </div>
    </nav>
</template>

<script lang="ts" setup>
import DsSystemIcon from "@sazka/design-system/src/icon/ds-system-icon.vue";
import { useAuthentication } from "@sazka/ng/authentication/composables/use-authentication";
import { ngAction } from "@sazka/ng/ng-integration";
import BalanceToggle from "./user-menu-balance-toggle.vue";

defineProps<{
    isOpen: boolean;
    myBetsLink: string;
}>();

const showAccount = () => ngAction("showMyAccount");
const showDeposit = () => ngAction("showDeposit");

const logout = async () => {
    await useAuthentication().logout();
};

const showBalance = defineModel<boolean>("showBalance");

defineEmits(["myBetsClick"]);
</script>
